import React, { useState } from 'react';
import { PromptSection } from './PromptSection';
import { GeneratedImagesGrid } from './GeneratedImagesGrid';
import { ProductMetadataSection } from './ProductMetadataSection';
import { aspectRatios } from '@/components/ui/image-size';
import { LoraModel } from '@/types/lora';

interface GenerateMainContentProps {
  prompt: string;
  setPrompt: (prompt: string) => void;
  handleGenerate: (numImages: number) => void;
  isGenerating: boolean;
  currentRatio: (typeof aspectRatios)[0];
  selectedLoraModel: LoraModel | null;
  setSelectedLoraModel: (model: LoraModel | null) => void;
  missingTriggerWords: string[];
  setIsAdvancedModalOpen: (isOpen: boolean) => void;
  handleResetSettings: () => void;
  validatePrompt: (prompt: string) => boolean;
  requiredTriggers: string[];
  stealthMode: boolean;
  setStealthMode: (value: boolean) => void;
  generatedImages: any;
  publicGeneratedImages: any;
  imagesProps: {
    isLoading: boolean;
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: () => void;
    totalCount: number;
  };
  publicImagesProps: {
    isLoading: boolean;
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: () => void;
    totalCount: number;
  };
  setFullscreenImage: (image: string | null) => void;
  status: 'pending' | 'success' | 'error' | null;
  textareaRef?: React.RefObject<HTMLTextAreaElement>;
  product: any;
  numImages: number;
  setNumImages: (value: number) => void;
}

export const GenerateMainContent: React.FC<GenerateMainContentProps> = ({
  prompt,
  setPrompt,
  handleGenerate,
  isGenerating,
  currentRatio,
  selectedLoraModel,
  setSelectedLoraModel,
  missingTriggerWords,
  setIsAdvancedModalOpen,
  handleResetSettings,
  validatePrompt,
  requiredTriggers,
  stealthMode,
  setStealthMode,
  generatedImages,
  publicGeneratedImages,
  imagesProps,
  publicImagesProps,
  setFullscreenImage,
  status,
  textareaRef,
  product,
  numImages,
  setNumImages,
}) => {
  return (
    <div className="w-full">
      <div className="space-y-4">
        <PromptSection
          prompt={prompt}
          setPrompt={setPrompt}
          handleGenerate={handleGenerate}
          isGenerating={isGenerating}
          currentRatio={currentRatio}
          selectedLoraModel={selectedLoraModel}
          setSelectedLoraModel={setSelectedLoraModel}
          missingTriggerWords={missingTriggerWords}
          setIsAdvancedModalOpen={setIsAdvancedModalOpen}
          handleResetSettings={handleResetSettings}
          validatePrompt={validatePrompt}
          requiredTriggers={requiredTriggers}
          stealthMode={stealthMode}
          setStealthMode={setStealthMode}
          textareaRef={textareaRef}
          numImages={numImages}
          setNumImages={setNumImages}
        />

        <div className="overflow-hidden rounded-lg">
          <GeneratedImagesGrid
            myImages={{
              images: generatedImages,
              isLoading: imagesProps.isLoading,
              hasNextPage: imagesProps.hasNextPage,
              isFetchingNextPage: imagesProps.isFetchingNextPage,
              onLoadMore: imagesProps.fetchNextPage,
              totalCount: imagesProps.totalCount,
            }}
            publicImages={{
              images: publicGeneratedImages,
              isLoading: publicImagesProps.isLoading,
              hasNextPage: publicImagesProps.hasNextPage,
              isFetchingNextPage: publicImagesProps.isFetchingNextPage,
              onLoadMore: publicImagesProps.fetchNextPage,
              totalCount: publicImagesProps.totalCount,
            }}
            setFullscreenImage={setFullscreenImage}
            isGenerating={isGenerating}
            status={status}
            maxHeight="calc(100vh - 300px)"
            isGalleryPage={false}
          />
        </div>

        {/* Product metadata - mobile only */}
        <div className="xl:hidden">
          <ProductMetadataSection product={product} />
        </div>
      </div>
    </div>
  );
};
